<main class="bg-white position-relative">
  <!-- search bar -->
  <div class="container">
    <div class="thank-sec padd-top-bot row">
      <div class="col-md-6 offset-md-3">
        <div class="receive-sec">
          <i class="flaticon-checked"></i>
          <h2>Order completed successfully!</h2>
          <p>Thank you for ordering. We received your order and will begin processing it soon. Your order
            information appears below</p>
          <div class="thank-btn">
            <a class="border-btn" routerLink="">back to home</a>
            <a class="bg-btn" routerLink="/confirmation">view order</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- top_selling_sec -->
</main>
